import React, { useRef, useState, useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import Menu from './Menu';
import MenuItem from './MenuItem';
import ToggleButton from './ToggleButton';
export const getStyles = createUseStyles({
    root: {
        position: 'relative',
    },
    input: { position: 'absolute', left: 0, right: 0 },
});
const Dropdown = ({ labelText, links = [], defaultValue, disabled, className, }) => {
    const styles = getStyles();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [value, setValue] = useState(defaultValue);
    const [filterValue, setFilterValue] = useState('');
    const filteredLinks = useMemo(() => links.filter(link => !filterValue ||
        link.label.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1), [filterValue, links]);
    const inputEl = useRef(null);
    const handleButtonClick = () => {
        setIsMenuOpen(true);
        inputEl.current.focus();
    };
    const handleBlur = () => setTimeout(() => {
        setIsMenuOpen(false);
        inputEl.current?.blur();
    }, 100);
    return (React.createElement("nav", { className: classNames(styles.root, className) },
        React.createElement("h2", null,
            React.createElement(ToggleButton, { onClick: handleButtonClick, isOpen: isMenuOpen, value: value, disabled: disabled },
                React.createElement("input", { className: styles.input, type: "text", ref: inputEl, value: isMenuOpen ? filterValue : labelText, onChange: e => setFilterValue(e.currentTarget.value), onBlur: handleBlur }))),
        React.createElement(Menu, { isOpen: isMenuOpen },
            React.createElement("ul", null, filteredLinks.map(({ to, label, onClick }) => (React.createElement(MenuItem, { to: to, key: to, setValue: setValue, onClick: onClick }, label)))))));
};
export default Dropdown;
//# sourceMappingURL=Dropdown.js.map